export function getAssemblyScaffold(method = "fragment_synthesis", components = []) {
  const compList = Array.isArray(components) && components.length > 0 ? components : null;
  switch (method) {
    case "golden_gate":
      return `method: golden_gate

enzyme: BsmBI

circularize: true

sequence_components:
${compList ? compList.map((c) => `  - ${c}`).join("\n") + "\n" : "  - part1.gb\n  - part2.gb\n"}`;
    case "gateway":
      return `method: gateway

description: sample gateway cloning product

sequence_components:
${compList ? compList.map((c) => `  - ${c}`).join("\n") + "\n" : "  - entry_clone1.gb\n  - entry_clone2.gb\n  - destination_vector.gb\n"}`;
    case "genscript_restriction":
      return `method: genscript_restriction

vector: pUC57_Mini_Key_IIS_Free.gb

circularize: true

enzymes:
  - EcoRV
  - AatII

sequence_components:
${compList ? compList.map((c) => `  - ${c}`).join("\n") + "\n" : "  - insert.gb\n"}`;
    case "genscript_seamless":
      return `# -------------------------------------------------
# Warning: genscript_restriction is generally cheaper
# than genscript_seamless since it qualifies for FLASH service
# -------------------------------------------------
method: genscript_seamless

vector: vector.gb

sequence_components:
${compList ? compList.map((c) => `  - ${c}`).join("\n") + "\n" : "  - insert.gb\n"}
homology_arm_5: GCTAGCTAGCTAGCTA_50BP_MINIMUM_HOMOLOGY_ARM_SEQUENCE_HERE

homology_arm_3: ATGCATGCATGCATGC_50BP_MINIMUM_HOMOLOGY_ARM_SEQUENCE_HERE

circularize: true
`;
    case "fragment_synthesis":
      return `method: fragment_synthesis

circularize: false

sequence_components:
${compList ? compList.map((c) => `  - ${c}`).join("\n") + "\n" : "  - part1.gb\n  - part2.gb\n"}`;
    case "mutagenesis":
      return `method: mutagenesis

description: Mutagenesis construct

template: ${compList && compList.length > 0 ? compList[0] : "template.gb"}

mutations:
  - before: ACTGCTAGTCGTATGTA
    after: ACTGCTAGTCGGATGTA

circularize: true
`;
    case "twist_clonal_synthesis":
      return `method: twist_clonal_synthesis

vector: pTwist_ENTR.gb

sequence_components:
${compList ? compList.map((c) => `  - ${c}`).join("\n") + "\n" : "  - insert.gb\n"}`;
    case "restriction":
    default:
      return `method: restriction

vector: vector.gb

enzymes:
  - EcoRI
  - BamHI

blunt: false

circularize: true

sequence_components:
${compList ? compList.map((c) => `  - ${c}`).join("\n") + "\n" : "  - insert.gb\n"}`;
  }
}
